import z from "zod";

// Safe subset of member fields for notice author
export const NoticeAuthorSchema = z.object({
  id: z.string(),
  firstName: z.string(),
  lastName: z.string(),
  avatar: z.string().optional(),
  businessName: z.string().optional(),
});

export type NoticeAuthor = z.infer<typeof NoticeAuthorSchema>;

export const NoticeSchema = z.object({
  id: z.string(),
  locationId: z.string(),
  message: z.string(),
  authorId: z.string(),
  author: NoticeAuthorSchema.optional(),
  createdAt: z.union([z.string(), z.coerce.string()]), // ISO date string or Date object
  updatedAt: z.union([z.string(), z.coerce.string()]), // ISO date string or Date object
});

export type Notice = z.infer<typeof NoticeSchema>;

// Deprecated: Use Notice instead
export const NotificationSchema = NoticeSchema;
export type Notification = Notice;
